import * as Sentry from '@sentry/react';

import type { EnvironmentConfig } from '@luna/env';
import { isFeatureEnabled } from '@luna/gatekeeper';
import { logger } from '@luna/logger';
import { normalizePath } from '@luna/router';

import { normalizeBreadcrumb, normalizeEvent } from './normalizeService';
import { createMaxErrorsPerSessionMiddleware } from './maxErrorsPerSessionMiddlewareService';
import { createNoNetworkErrorsMiddleware } from './noNetworkErrorsMiddlewareService';

export function initSentry(environmentConfig: EnvironmentConfig): void {
    try {
        if (!environmentConfig.sentry || !isFeatureEnabled((f) => f.sentry) || window.Cypress) {
            return;
        }
        Sentry.init({
            dsn: environmentConfig.sentry.dsn,
            environment: `${environmentConfig.country}-${environmentConfig.environment}`,
            integrations: [
                Sentry.browserSessionIntegration(),
                Sentry.browserTracingIntegration({
                    beforeStartSpan: (context) => {
                        return {
                            ...context,
                            name: normalizePath(window.location.hash),
                        };
                    },
                }),
            ],
            enableLogs: environmentConfig.sentry.enableLogs,
            release: environmentConfig.version,
            tracesSampleRate: environmentConfig.sentry.tracesSampleRate,
            dist: environmentConfig.version,
            attachStacktrace: true,
            beforeBreadcrumb: normalizeBreadcrumb,
            beforeSend: createNoNetworkErrorsMiddleware(
                createMaxErrorsPerSessionMiddleware(normalizeEvent, {
                    maxErrorsPerSession: environmentConfig.sentry.maxErrorsPerSession,
                }),
            ),
        });
    } catch (error) {
        logger.error('sentry init failed', { error });
    }
}
